import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lastVisitedRoute: '/',
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setLastVisitedRoute: (state, action) => {
      state.lastVisitedRoute = action.payload;
      localStorage.setItem('lastVisitedRoute', action.payload); // persist
    },
    loadPersistedRoute: (state) => {
      state.lastVisitedRoute = localStorage.getItem('lastVisitedRoute') || '/';
    },
  },
});

export const { setLastVisitedRoute, loadPersistedRoute } = navigationSlice.actions;
export default navigationSlice.reducer;